export const columnasDetalleNomina = [
  {
    key: 'id',
    label: 'id',
    sorted: true,
    fixed: false,
    type: 'string',
    hidden: true,
  },
  {
    key: 'errores',
    label: 'errores',
    sorted: false,
    fixed: false,
    type: 'string',
    hidden: true,
    // tooltip: '',
    // tooltipPosition: 'bottom-end',
  },
  {
    key: 'tip_doc',
    label: 'Tipo de documento',
    sorted: false,
    fixed: false,
    type: 'number',
    hidden: true,
  },
  {
    key: 'tipo_doc_show',
    label: 'Tipo de documento',
    sorted: false,
    fixed: false,
    type: 'string',
    hidden: false,
  },
  {
    key: 'nro_doc',
    label: 'N° de documento',
    sorted: false,
    fixed: false,
    type: 'string',
    hidden: false,
  },
  {
    key: 'cuil',
    label: 'CUIL',
    sorted: false,
    fixed: false,
    type: 'string',
    hidden: false,
  },
  {
    key: 'nombre',
    label: 'Apellido y nombre',
    sorted: true,
    fixed: false,
    type: 'string',
    hidden: false,
  },
  {
    key: 'sexo',
    label: 'Sexo',
    sorted: false,
    fixed: false,
    type: 'string',
    hidden: false,
  },
  {
    key: 'cant_dias_trabajados',
    label: 'Días trabajados',
    sorted: false,
    fixed: false,
    type: 'number',
    hidden: false,
  },
  {
    key: 'fec_nac',
    label: 'Fecha de nacimiento',
    sorted: false,
    fixed: false,
    type: 'string',
    hidden: false,
  },
  {
    key: 'sueldo',
    label: 'Sueldo',
    sorted: false,
    fixed: false,
    type: 'number',
    hidden: false,
  },
  {
    key: 'acciones',
    label: '',
    sorted: false,
    fixed: false,
    type: 'string',
    hidden: false,
  },
]
